const modalForm = () => {
  const btns = document.querySelectorAll(".modal-btn");
  if (btns.length > 0) {
    btns.forEach((btn) => {
      const position = btn.getAttribute("data-position");
      const modal = document.querySelector(btn.getAttribute("data-bs-target"));

      btn.addEventListener("click", () => {
        const modalTitle = modal.querySelector(".modal-title");
        const hidden = modal.querySelector(".wrap-submit .wpcf7-hidden");
        modalTitle.innerHTML = position;
        hidden.value = position;
      });

    });
  }
};

export default modalForm;
